












import {
  defineComponent, ref, watch,
} from '@vue/composition-api';

import Verte from 'verte';
import 'verte/dist/verte.css';

const ThemeColorsInput = defineComponent({
  props: {
    value: {
      type: Array,
      default: () => [
        { key: 'primary', colorCode: '#00D190' },
        { key: 'secondary', colorCode: '#1F60C6' },
      ],
    },
  },
  setup(props, context) {
    const primaryColor = ref('#00D190');
    const secondaryColor = ref('#1F60C6');

    const firstTimeWatch = ref(true);
    // HACK: It seems that Vue can't derived type from Array with default
    watch(() => props.value as { key: string; colorCode: string }[], (newValue, oldVal) => {
      if (firstTimeWatch.value) {
        // props.value
        const priColor = newValue.find((c) => c.key === 'primary')?.colorCode.toUpperCase() !== primaryColor.value.toUpperCase();
        const secColor = newValue.find((c) => c.key === 'secondary')?.colorCode.toUpperCase() !== secondaryColor.value.toUpperCase();
        if (priColor || secColor) {
          primaryColor.value = newValue.find((c) => c.key === 'primary')?.colorCode || '#00D190';
          secondaryColor.value = newValue.find((c) => c.key === 'secondary')?.colorCode || '#1F60C6';
          firstTimeWatch.value = false;
        }
      }
    });

    const primaryColorChange = (colorCode: string) => {
      primaryColor.value = colorCode;
      context.emit('input', [
        { key: 'primary', colorCode },
        { key: 'secondary', colorCode: secondaryColor.value },
      ]);
    };

    const secondaryColorChange = (colorCode: string) => {
      secondaryColor.value = colorCode;
      context.emit('input', [
        { key: 'primary', colorCode: primaryColor.value },
        { key: 'secondary', colorCode },
      ]);
    };

    return {
      primaryColor,
      secondaryColor,
      primaryColorChange,
      secondaryColorChange,
    };
  },
  components: {
    Verte,
  },
});

export default ThemeColorsInput;
